import React, { useEffect } from "react";

interface ToastProps {
  message: string;
  type?: "success" | "error";
  onClose: () => void;
  duration?: number;  
}


const Toast: React.FC<ToastProps> = ({message, type = "success",onClose,duration = 1500}) => {
   useEffect(() => {
    if (duration === 0) return;
     const timer = setTimeout(() => {
        onClose();
     },duration);

     return () => clearTimeout(timer);
   },[onClose,duration]);

   
   return(
   <div className={`toast show ${type}`}>
      <span className="toast-message">{message}</span>
      <button className="toast-close" onClick={onClose}>
        &times;
      </button>
    </div>
   );
} 

export default Toast;